import {useDebugValue} from 'react';

import {noop} from '../../../utils/noop';

import {useEvents} from './useEvents';

const defaultSubmitSummaryEvents = {
    onClick: noop
};

function useSubmitSummaryEvents(props) {
    const {
        submitSummaryEvents: propsSubmitSummaryEvents
    } = props;

    const {
        events: submitSummaryEvents
    } = useEvents(defaultSubmitSummaryEvents, propsSubmitSummaryEvents);

    const result = {
        submitSummaryEvents
    };

    useDebugValue(result);

    return result;
}

export {useSubmitSummaryEvents};
